import * as React from "react";
import type { SVGProps } from "react";
const SvgRadioOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <circle cx={10} cy={10} r={9} stroke="#74758C" strokeWidth={2} />
  </svg>
);
export default SvgRadioOff;
